var map = {
	"./Maestro.svg": 5985,
	"./PayPal.svg": 3608,
	"./americanexpress.svg": 8492,
	"./apple_pay.svg": 1052,
	"./bed.svg": 983,
	"./bmb.svg": 4836,
	"./bmb_full.svg": 2741,
	"./bullseye.svg": 1243,
	"./chevron-down.svg": 5664,
	"./circle-exclamation.svg": 4293,
	"./cleaning.svg": 8146,
	"./clock.svg": 5128,
	"./crown.svg": 6605,
	"./envelope.svg": 827,
	"./event.svg": 3103,
	"./eye.svg": 6469,
	"./google_pay.svg": 4327,
	"./house.svg": 9686,
	"./ideal.svg": 987,
	"./layers.svg": 6245,
	"./list.svg": 6322,
	"./location.svg": 2026,
	"./mastercard.svg": 9831,
	"./money.svg": 148,
	"./mug.svg": 7101,
	"./news.svg": 4538,
	"./photo-film.svg": 9907,
	"./plane-arrive.svg": 6958,
	"./plane-departure.svg": 3443,
	"./scape.svg": 9394,
	"./settings.svg": 2110,
	"./tv.svg": 212,
	"./users.svg": 384,
	"./visa2.svg": 4825,
	"./wifi.svg": 3610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;